module.exports = __webpack_public_path__ + "static/img/xiaoshubao1122.8d70b05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/xiaoshubao1122.png
// module id = COgj
// module chunks = 36